import * as React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalSeeker, ButtonSeeker } from 'ui-seeker/core'
import DayMonthRangesEditor from './DayMonthRangesEditor'

// Modal around DayMonthRangesEditor. Edits a local copy of `ranges`; `onConfirm(ranges)` may return a promise
// (the modal closes when it resolves, stays open if it rejects).
export default function DayMonthRangesModal({
    isOpen, controller, title, ranges, onConfirm, isSaving = false, confirmText, hint, selectedLabel, emptyLabel, note,
}) {
    const { t } = useTranslation('common')
    const [selected, setSelected] = useState([])
    const [isPending, setIsPending] = useState(false)

    useEffect(() => {
        if (!isOpen) return
        setSelected(ranges || [])
        setIsPending(false)
    }, [isOpen, ranges])

    const onSave = () => Promise.resolve(onConfirm(selected))
        .then(() => controller(false))
        .catch(() => {})

    return <ModalSeeker isOpen={isOpen} controller={controller} title={title} okBtn={false} cancelBtn={false} size="lg">
        {isOpen && <DayMonthRangesEditor
            ranges={selected}
            onChange={setSelected}
            onPendingChange={setIsPending}
            hint={hint}
            selectedLabel={selectedLabel}
            emptyLabel={emptyLabel}
            note={note}
        />}

        <div className="day-month-ranges-footer">
            <ButtonSeeker variant="outlined" onClick={() => controller(false)}>
                {t('common:actions.cancel')}
            </ButtonSeeker>
            <ButtonSeeker variant="contained" color="secondary" onClick={onSave} disabled={isSaving || isPending}>
                {confirmText || t('common:actions.save')}
            </ButtonSeeker>
        </div>
    </ModalSeeker>
}
